import {
  getCitation,
  getFormatted,
  getIndex,
  mergeItems
} from "../../lib/formatUtilities.js";
import { getField } from "../../lib/utilities.js";

export default {
  Title: "University of Missouri Output DO NOT MAP",
  template: "/templateFiles/missouri_template_v1_0.docx",
  outputSettings: { font: "Arial", fontSize: 10 },
  output: {
    // Current Positions is a part of bio
    bio: {
      field: "bio",
      map: {
        bio_name: "name",
        bio_officeAddress: "officeAddress",
        bio_workPhone: "workPhone",
        bio_workEmail: "workEmail",
        bio_title: "title",
        bio_dept: "dept",
        bio_institution: "institution"
      }
    },
    // Education
    edu: {
      field: "education",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "degree" },
            { key: "secondaryInfo" },
            { key: "location" }
          ])
        ]
      }
    },
    // Academic Appointments
    aa: {
      field: "facultyAppointments",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["title", "field", "location"] // TODO: Separate location into Institution and City, State
      }
    },
    // Professional Positions and Experience
    ppe: {
      field: "hospitalAppointments",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "title" }, { key: "field" }]), "location"] // TODO: Separate location into Institution and City, State
      }
    },
    // Certification and Licensure
    cert: {
      section: "certAndLic",
      field: "clinicalActivityAndInnovations",
      type: "Current Licensure and Certification",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "subspecialty" },
            { key: "location" }
          ])
        ]
      }
    },
    // Prodessional Development
    pd: {
      field: "profDevelopment",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "description" },
            { key: "location" }
          ])
        ]
      }
    },
    // Professional Memberships and Activities
    pma: {
      field: "societies",
      preface: true,
      format: {
        t: ["limitedMonthDayYear"],
        1: ["society"]
      },
      sublist: {
        roles: {
          t: ["limitedMonthDayYear"],
          1: [getFormatted("roles", { indent: 600 })]
        }
      }
    },
    // Editoral Board Appointments
    eba: {
      field: "editorialActivities",
      type: "board",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "organization" },
            { key: "comments" }
          ])
        ]
      }
    },
    // Committee Assignments and Administrative Services
    caas: {
      field: "committeeService",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "role" },
            { key: "institution" }
          ])
        ]
      }
    },
    // Clinical / Quality Improvement Activities
    cqia: {
      section: "clinicalQualityImprovement",
      field: "clinicalActivityAndInnovation",
      type: "Clinical Innovations",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "role" },
            { key: "institution" }
          ])
        ]
      }
    },
    // Educational Activities
    eduAct: {
      field: "teaching",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "role" }, { key: "title" }])]
      },
      sections: [
        { title: "Educational Administration", type: "educationalLeadership" },
        {
          title: "Training Program Committees",
          type: "Clinical Supervisory and Training Responsibilities"
        },
        { title: "Course and Curriculum Development", type: "educationalDev" },
        { title: "Courses Directed", type: "Teaching of Students in Courses" },
        { title: "Didactic Sessions", type: "postdocs" },
        {
          title: "Clinical Teaching",
          type: "Formal Teaching of Peers (e.g., CME and other continuing education courses)"
        },
        {
          title: "Laboratory Teaching",
          type: "Laboratory and Other Research Supervisory and Training"
        },
        {
          title: "Small Group Teaching",
          type: "Other Mentored Trainees and Faculty"
        },
        {
          title: "Graduate Student Committees",
          type: "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)"
        }
      ]
    },
    // Honors and Awards
    hon: {
      field: "honors",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "location" },
            { key: "description" }
          ])
        ]
      }
    },
    // Grants and Contract Awards
    gra: {
      field: "projects",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "agency" },
            { key: "grantTypeAndNumber" },
            { key: "directCosts" },
            { key: "role" },
            { key: "piName" },
            { key: "workTime", suffix: " effort" }
          ])
        ]
      }
    },
    // Publications
    sch: {
      field: "scholarship",
      preface: true,
      format: {
        1: getIndex,
        2: function (item, i, cvDef, genOpts) {
          return [
            getCitation("line")(item, i, cvDef, genOpts),
            getFormatted("comments", { indent: 600 })(item, i, cvDef, genOpts)
          ].join(genOpts.noXML ? "<br>" : "");
        }
      },
      sections: [
        { title: "Peer-Reviewed", type: "Research Investigations" },
        {
          title: "Non-Peer Reviewed",
          type: "Proceedings of meetings or other non-peer reviewed scholarship"
        },
        { title: "Articles Accepted for Publication", type: "preprints" },
        { title: "Books and Monographs", type: "books" },
        { title: "Evidence of Works in Progress", type: "otherPeer" },
        {
          title: "Development and/or Publication of Educational Materials",
          type: "Professional educational materials or reports, in print or other media"
        },
        {
          title:
            "Development of Major Curricular Offerings or Innovative Educational Programs",
          type: "education"
        },
        { title: "Non-Print Materials", type: "nonPrint" }
      ]
    },
    // Published Abstracts and Presentations
    presSection: {
      toggle: function (cvDef, filter, { customExportSettings }) {
        var emptySections =
          typeof customExportSettings != "undefined" &&
          customExportSettings.emptySections != null &&
          !!customExportSettings.emptySections;
        return (
          emptySections ||
          getField(cvDef, "presentations").filter(filter).length > 0
        );
      }
    },
    // Oral Presentations
    pres1: {
      field: "presentations",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["title"]
      },
      sections: [
        {
          title: "Invited Presentations",
          filter: (n) => n.presType == "Oral" && n.invited
        },
        {
          title: "National/International Meetings",
          filter: (n) =>
            n.presType == "Oral" &&
            !n.invited &&
            n.meetingType == "National/International"
        },
        {
          title: "Local/Regional Meetings",
          filter: (n) =>
            n.presType == "Oral" &&
            !n.invited &&
            n.meetingType == "Local/Regional"
        },
        {
          title: "Peer-reviewed Presentations",
          filter: (n) =>
            n.presType == "Oral" &&
            !n.invited &&
            n.meetingType == "Peer-Reviewed"
        },
        {
          title: "Grand Rounds Presentations",
          filter: (n) =>
            n.presType == "Oral" &&
            !n.invited &&
            n.meetingType == "Grand Rounds"
        }
      ]
    },
    // Poster Presentations
    pres2: {
      field: "presentations",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["title"]
      },
      sections: [
        {
          title: "National/International Meetings",
          filter: (n) =>
            n.presType == "Poster" && n.meetingType == "National/International"
        },
        {
          title: "Local/Regional Meetings",
          filter: (n) =>
            n.presType == "Poster" && n.meetingType == "Local/Regional"
        }
      ]
    },
    osch: {
      section: "otherPublications",
      field: "scholarship",
      preface: true,
      format: {
        1: getIndex,
        2: function (item, i, cvDef, genOpts) {
          return [
            getCitation("line")(item, i, cvDef, genOpts),
            getFormatted("comments", { indent: 600 })(item, i, cvDef, genOpts)
          ].join(genOpts.noXML ? "<br>" : "");
        }
      },
      sections: [
        { title: "Social Media", type: "media" },
        { title: "Other Creative Products", type: "creativeWriting" },
        { title: "Other Scholarly Products", type: "short" }
      ]
    },
    // Patents and Technology
    pat: {
      field: "technologyAndScienceInnovations",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "description" },
            { key: "source" }
          ])
        ]
      }
    },
    // Professional Community Activities
    com: {
      field: "community",
      preface: true,
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "role" },
            { key: "description" },
            { key: "comments" }
          ])
        ]
      }
    }
  }
};
